export default __webpack_public_path__ + "static/media/Pet-Grooming.3bff3621.webp";